import React from 'react'

const Loader = () => {
  return (
    <>
      <div className="preloader" />
    </>
  );
}

export default Loader